// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"23a7166c","359":"bdbb544c","623":"b239b68b"}[chunkId] + ".chunk.js";
};